export const NAME = 'extraLicensesPurchase';
